"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var border = function (color) { return "border: 1px solid " + color + ";"; };
exports.default = (function (_a) {
    var checked = _a.checked, hovered = _a.hovered, disabled = _a.disabled;
    return function (_a) {
        var theme = _a.theme;
        if (hovered) {
            return border(theme.palette.inputCheckBoxBorderHover);
        }
        if (checked && disabled) {
            return border(theme.palette.inputCheckBoxBorder);
        }
        return border(checked ? theme.palette.inputCheckBoxBgChecked[0] : theme.palette.inputCheckBoxBorder);
    };
});
